import { Enrolment } from '@/models/enrolment';

import { Event } from './event';

export class EnrolmentsAcquiredEvent extends Event<Enrolment[]> {}
